//Componente importado de material ui
import { createMuiTheme } from '@material-ui/core';
import { tipografia } from '../../../AppStyle';
/**
 * @constant theme
 * Contiene las clases de material que se aplican al componenteRadioButton
 * Sobreescribe las clases de material con el estilo que aquí se aplica
 */
const theme = createMuiTheme({
    overrides: {
        MuiFormHelperText: {
            root: {
                color: '#f44336',
            },

        },
        MuiFormControlLabel: {
            label: {
                fontSize: '14px',
                fontFamily: tipografia.regular,
                fontWeight: 'bold',
                lineHeight: '17px',
                marginBottom: '5px',
                letterSpacing: '0',
                color: ' #333333',
            },
        },
        MuiFormGroup: {
            root: {
                display: 'inline',
                paddingTop: '0px',
                paddingBottom: '13px',
                paddingLeft: '12px',
                opacity: '0.8',
                color: '#333333',
                fontFamily: tipografia.regular,
                height: '48px',
                width: '328px',
            },
        },
        MuiIconButton: {
            label: {
                boxSizing: 'border-box',
                color: '#087021',
                border: '12px'
            },
        },
        icon: {
            color: 'red'
        }
    },
});

export default theme;